import React from 'react';

import FilterAutocomplete from 'components/FilterAutocomplete/FilterAutocomplete';
import { Filter } from 'components/FilterAutocomplete/types/filter';
import { Filters } from 'context/FilterProvider/types/Filters';
import { getOptionsForFilter } from 'utils/filter';

type FramesFiltersListProps = {
  filterValues: Filter[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filterResponse: Filters;
};

const FramesFiltersList = ({
  filterValues,
  setSelectedFilters,
  filterResponse,
}: FramesFiltersListProps) => {
  return (
    <span>
      {filterValues.map((filter) => {
        return (
          <FilterAutocomplete
            filterKey={filter.key}
            label={filter.label}
            options={getOptionsForFilter(filter.key, filterResponse)}
            setSelectedFilters={setSelectedFilters}
          />
        );
      })}
    </span>
  );
};

export default FramesFiltersList;
